// apps/client/src/components/XeroSyncAccounts.tsx

import React from 'react';
import { XeroSyncAccountsResponse, XeroSyncType } from '@avanzu/types';
import { XeroSyncButton } from './XeroSyncButton';

interface XeroSyncAccountsProps {
  onSyncComplete?: (result: XeroSyncAccountsResponse) => void;
  variant?: 'contained' | 'outlined' | 'text';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
  disabled?: boolean;
}

const XeroSyncAccounts: React.FC<XeroSyncAccountsProps> = (props) => {
  return (
    <XeroSyncButton<XeroSyncAccountsResponse>
      syncType={XeroSyncType.ACCOUNTS}
      pollInterval={250}
      {...props}
    />
  );
};

export default XeroSyncAccounts;
